// Module
var code = `<button
  data-event-type="scriptContent"
  data-script-num="{{scriptNum}}"
  data-parent-vsid="{{parentVsid}}"
  data-button-type="codePlayground"
>
  {{tabName}}
</button>
`;
// Exports
module.exports = code;